import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Grid,
  Box,
  Chip,
  Typography,
  Modal,
  Tabs,
  Tab,
  Tooltip,
  Divider,
  Button,
  Card,
  CardHeader,
  CardContent
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import WestRoundedIcon from "@mui/icons-material/WestRounded";
import WysiwygRoundedIcon from "@mui/icons-material/WysiwygRounded";
import PropTypes from "prop-types";
import { api } from "../api";
import { TextField } from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import { fetchToken } from "../auth/Token";
import { toast } from 'sonner';
import { Cancel, CheckCircle } from "@mui/icons-material";
import AssessmentIcon from '@mui/icons-material/Assessment';

const Item1 = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: 'groove',
  border: '3px',
  borderColor:'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',
  minHeight:'50px',
  borderRadius:'10px'
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SocietyAccountsDashboard = ({ isOnline }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  const society_name = location.state && location.state.society_name;
  const society_id = location.state && location.state.society_id;
  const [open_customize, setOpen_customize] = useState(false);
  const [value1, setValue1] = useState(0);
  const [structure_name, setStructure_name] = useState("");
  const [all_structure, setAll_Structure] = useState([]);
  const [selected_wids, setSelected_wids] = useState([]);
  const [editing_mode, setEditing_mode] = useState(false);
  const [editing_id, setEditing_id] = useState(null);
  const [periodic_state, setPeriodicState] = useState("weekly");
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [inflows, setInflows] = useState([]);

  const goToInflows = () => {
    navigate('/inflows', {
      state: {
        society_name: society_name,
        society_id: society_id
      }
    });
  }

  const goToFinancialStatement = () => {
    navigate('/financial-statements', {
      state: {
        society_name: society_name,
        society_id: society_id
      }
    });
  }


  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const callData = () => {

    const data2 = new FormData();
    data2.append("society_id", society_id);
    data2.append("start_date", start_date);
    data2.append("end_date", end_date);

    toast.promise(
      api.post("/dashboards/get/all/inflows", data2,  {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading:  "Loading Data...",
        success: (response) => {
          setInflows(response.data);
          // console.log(response.data)

          return "Successfully Loaded";
        },
        error: (error) => {
          console.log(error);

          return "An error Occurred, try again later";
        },
      }
    );


  }

  useEffect(() => {
    callData()
  },[])

  useEffect(() => {
    callData()
  },[start_date, end_date])


  const handleEditing = (item) => {
    setEditing_id(item.id);
    setEditing_mode(true);
    const arry = item?.widgets.map(flow => flow.id);
    setSelected_wids(arry);
    setValue1(1);
    setStructure_name(item.structure_name);
  }




  const setDefaultStructure = (id) => {
    toast.promise(
      api.get(`/dashboards/set/default/dash_structure/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading:  "Making Changes...",
        success: (response) => {
          fetch_needs();
          callData();
          return response.data;
        },
        error: (error) => {
          console.log(error);

          return "An error Occurred, try again later";
        },
      }
    );
  }

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const createThing = () => {
    const data = {
      name: structure_name,
      data: selected_wids,
      editing_mode: editing_mode,
      editing_id: editing_id,
    };

    if(!structure_name && !selected_wids[0]){
      return toast.error('Please add a name and at least one widget')
    }

    toast.promise(
      api.post("/dashboards/create/dash_structure", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: editing_mode? "Editing..." : "Creating...",
        success: (response) => {
          close_modal();
          fetch_needs();
          callData();
          return response.data;
        },
        error: (error) => {
          console.log(error);

          return "An error Occurred, try again later";
        },
      }
    );
  };
  const deleteThing = (id) => {
    toast.promise(
      api.get(`/dashboards/delete/structure/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Deleting...",
        success: (response) => {
          fetch_needs();
          callData();
          return response.data;
        },
        error: (error) => {
          console.log(error);

          return "An error Occurred, Please try again later";
        },
      }
    );
  };

  const fetch_needs = () => {
    const storedStructure = localStorage.getItem("all_stored_structure");

    if (!isOnline) {
      setAll_Structure(JSON.parse(storedStructure));
    } else {

      api
        .get("/dashboards/bring/all/dash_structure", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAll_Structure(response.data?.data);
          localStorage.setItem(
            "all_stored_structure",
            JSON.stringify(response.data?.data)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetch_needs();
  }, []);


  const close_modal = () => {
    setOpen_customize(false);
    setStructure_name("");
    setSelected_wids([]);
    setEditing_mode(false);
    setValue1(0);
    callData();
  };

  const toggleFWidgetSelection = (widId) => {
    setSelected_wids((prevWidgets) =>
      prevWidgets.includes(widId)
        ? prevWidgets.filter((id) => id !== widId)
        : [...prevWidgets, widId]
    );
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleOpen_customize = () => {
    setOpen_customize(!open_customize);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Grid container spacing={2} sx={{ ml: 1 }}>
      {/* return to dashboard and header */}
      <Grid item xs={12} md={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ mr: "auto" }}>
            <Chip
              icon={<WestRoundedIcon />}
              size="medium"
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Main Dashboard</b>
                </Typography>
              }
              sx={{
                borderRadius: 2,
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#fff",
                color: "#000",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                },
              }}
              onClick={() => navigate(-1)}
            />
            <Box>
              <Chip
                icon={<DashboardRoundedIcon />}
                size="medium"
                label={
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Create Dashboard</b>
                  </Typography>
                }
                sx={{
                  borderRadius: 2,
                  m: 1,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                  color: "#000",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  },
                }}
                onClick={handleOpen_customize}
              />
            </Box>
            <Box>
              <Chip
                icon={<AssessmentIcon />}
                size="medium"
                label={
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Financial Statements</b>
                  </Typography>
                }
                sx={{
                  borderRadius: 2,
                  m: 1,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                  color: "#000",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  },
                }}
                onClick={goToFinancialStatement}
              />
            </Box>
          </Box>
          <Box sx={{ mr: "auto", display: "block" }}>
            <Typography
              variant="h3"
              sx={{ textAlign: "center" }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Accounts Dashboard</b>
            </Typography>
            <Typography
              variant="h5"
              sx={{ textAlign: "center" }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>{society_name}</b>
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={12}>
        <Box sx={{ display:'flex', justifyContent:'center' }}>
          <TextField
            type="date"
            size="small"
            required
            variant="outlined"
            helperText="From"
            name="start_date"
            onChange={(e) => setStart_date(e.target.value)}
            value={start_date}
            sx={{ mr: 1 }}
          />

          <TextField
            type="date"
            size="small"
            required
            variant="outlined"
            helperText="To"
            name="end_date"
            onChange={(e) => setEnd_date(e.target.value)}
            value={end_date}
            sx={{ mr: 1 }}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={12} sx={{ mx:4 }}>
          <Item1>
            <Typography
              variant="h5"
              sx={{ textAlign: "center", textDecoration:'underline', cursor:'pointer' }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              onClick={goToInflows}
            >
              <Tooltip title="View Inflows">
                <b>Inflows</b>
              </Tooltip>
            </Typography>

            <Box>
              <Typography
                variant="h1"
                sx={{ textAlign: "center" }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{currencyFormat.format(inflows?.inflow)}</b>
              </Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} container spacing={2}>
                {/* First Row */}
                <Grid item xs={4}>
                  <Box>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Savings</b>
                    </Typography>
                    <Divider variant="middle" />
                    
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Dues Accounts: {currencyFormat.format(inflows?.total_dues)}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Boafo Accounts: {currencyFormat.format(inflows?.total_boafo)}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Extra Saving Accounts: {currencyFormat.format(inflows?.total_extra)}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Cooperative Accounts: {currencyFormat.format(inflows?.total_minimum_balance)}</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Loans</b>
                    </Typography>
                    <Divider variant="middle" />
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Repayments: {currencyFormat.format(inflows?.total_repayment)}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Application Fees: {currencyFormat.format(inflows?.total_application_fee)}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Processing Fee: {currencyFormat.format(inflows?.total_proccessing)}</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Shares</b>
                    </Typography>
                    <Divider variant="middle" />
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Purchased Shares: {currencyFormat.format(inflows?.total_shares)}</b>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              
              {/* Second Row */}
              <Grid item xs={12} container spacing={2}>
                <Grid item xs={4}>
                  <Box>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Investments</b>
                    </Typography>
                    <Divider variant="middle" />
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Cooperative Investments: {currencyFormat.format(inflows?.total_cooperative_investment)}</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Warehousing & Tradings</b>
                    </Typography>
                    <Divider variant="middle" />
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Warehouse Charges: {currencyFormat.format(inflows?.warehouse_charges)}</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box>
                    <Typography
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Others</b>
                    </Typography>
                    <Divider variant="middle" />
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Member Registration Fee: {currencyFormat.format(inflows?.total_registration_fee)}</b>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Item1>
      </Grid>

      <Grid item xs={12} md={12} sx={{ mx:4 }}>
         <Item1>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h1"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>Net Profit/Loss: <span style={{ color: inflows?.net_profit_or_loss >= 0?'green':'red' }}>{currencyFormat.format(inflows?.net_profit_or_loss)}</span></b>
          </Typography>
         </Item1>
      </Grid>

      <Grid item xs={12} md={12} sx={{ mx:2, display:'flex', justifyContent: 'space-around' }}>
        <Box sx={{ mx:4, width:'50%' }}>
          <Item1>
            <Typography
              variant="h5"
              sx={{ textAlign: "center", textDecoration:'underline' }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Incomes</b>
            </Typography>
            <Box>
              <Typography
                variant="h1"
                sx={{ textAlign: "center", color:'green' }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{currencyFormat.format(inflows?.income)}</b>
              </Typography>
            </Box>
            
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Dues Accounts: {currencyFormat.format(inflows?.total_dues)}</b>
            </Typography>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Loan Interest: {currencyFormat.format(inflows?.total_interest)}</b>
            </Typography>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Member Registration Fee: {currencyFormat.format(inflows?.total_registration_fee)}</b>
            </Typography>
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Warehouse Charges: {currencyFormat.format(inflows?.warehouse_charges)}</b>
            </Typography>

          </Item1>
        </Box>
      
        <Box sx={{ mx:4, width:'50%' }}>
          <Item1>
            <Typography
              variant="h5"
              sx={{ textAlign: "center", textDecoration:'underline' }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Expenditure</b>
            </Typography>
            <Box>
              <Typography
                variant="h1"
                sx={{ textAlign: "center", color:'red' }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{currencyFormat.format(inflows?.expenditure)}</b>
              </Typography>
            </Box>
            
            <Box sx={{ display:'flex', justifyContent:'space-around' }}> 
              <Box>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Loan Disbursed: {currencyFormat.format(inflows?.loan_disbursed)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Cooperative Investment Returns: {currencyFormat.format(inflows?.investment_returns)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Saving Boxes: {currencyFormat.format(inflows?.saving_boxes)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Phones: {currencyFormat.format(inflows?.phones)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Stationeries: {currencyFormat.format(inflows?.stationaries)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Office Maintenance: {currencyFormat.format(inflows?.office)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Passbooks: {currencyFormat.format(inflows?.passbooks)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>IT Equipments: {currencyFormat.format(inflows?.it_equipment)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Travel Allowance: {currencyFormat.format(inflows?.travel_allowance)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Office Rent: {currencyFormat.format(inflows?.office_rent)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Internet & Communications: {currencyFormat.format(inflows?.internet_com)}</b>
                </Typography>
              </Box>
              <Box>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Light Bills: {currencyFormat.format(inflows?.light_bill)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Staff Training: {currencyFormat.format(inflows?.staff_training)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Hotel Bills: {currencyFormat.format(inflows?.hotel_bills)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Technical Support Visits: {currencyFormat.format(inflows?.technical_assists)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Vehicles: {currencyFormat.format(inflows?.motor_bikes)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Fuel: {currencyFormat.format(inflows?.fuel)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Vehicle Maintenance: {currencyFormat.format(inflows?.vehicle_maintenance)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Staff Motivation: {currencyFormat.format(inflows?.staff_motivation)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Software Subscription: {currencyFormat.format(inflows?.software_rentals)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Leaders Allowance: {currencyFormat.format(inflows?.leaders_allowance)}</b>
                </Typography>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                  <b>Set up cost: {currencyFormat.format(inflows?.set_up)}</b>
                </Typography>
              </Box>
            </Box>
          </Item1>
        </Box>
      </Grid>

              

      <Modal
        open={open_customize}
        onClose={handleOpen_customize}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Button
                size="small"
                color="error"
                variant="contained"
                sx={{
                  borderRadius: 2,
                  ml: 'auto',
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                  },
                }}
                onClick={close_modal}
              >
                Close
              </Button>
            </Grid>
            <Grid item xs={2} md={2}>
              <Tabs
                sx={{ position: "fixed" }}
                value={value1}
                orientation="vertical"
                variant="scrollable"
                onChange={handleChange1}
                aria-label="basic tabs example"
              >
                <Tab
                  label={
                    <b
                      style={{
                        fontStyle: "normal",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Structures
                    </b>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    <b
                      style={{
                        fontStyle: "normal",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Create Structure
                    </b>
                  }
                  {...a11yProps(1)}
                />
              </Tabs>
            </Grid>
            <Grid item xs={12} md={10}>
              <CustomTabPanel value={value1} index={0}>
              <Box>
                  {all_structure && all_structure[0] ? (
                    <Box
                      sx={{
                        display:'flex',
                        flexWrap: 'wrap',
                        maxHeight: "80vh",
                        overflowY: "auto",
                        "&::-webkit-scrollbar": {
                          width: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                        p: 2,
                      }}
                    >
                      {all_structure && all_structure.map((item) => (
                        <Card
                          sx={{
                            maxWidth: 340,
                            m: item.default_str ? 0.5 : 3,
                            borderRadius: 7,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            borderStyle: "groove",
                            borderColor: 'grey',
                            cursor: 'pointer'
                          }}
                          key={item.id}
                        >
                          <CardHeader
                            title={
                              <Typography
                                variant="h5"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>{item.structure_name}{editing_mode && editing_id == item.id ?' (currently editing)':null}</b>
                              </Typography>
                            }
                            subheader={
                              <Typography
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                variant="subtitle"
                              >
                                <b>Created on: {formatDateToYearMonthDay(new Date(item.date_created))}</b>
                              </Typography>
                            }
                          />
                          <CardContent>
                            <Box
                              sx={{
                                display: "block",
                                justifyContent: "space-between",
                              }}
                            >
                              {item?.widgets && item?.widgets.map((flows_in) => (
                                <Box key={flows_in.id}>
                                  <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {flows_in.widget_name}
                                    </b>
                                  </Typography>
                                  <Divider variant='middle' sx={{ m:1 }} />
                                </Box>
                              ))}
                            </Box>
                            <Box
                              sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                sx={{ display: "inline-flex" }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <Chip
                                  sx={{
                                    m:1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                    minWidth: 0,
                                    "&:hover": {
                                      boxShadow:
                                        "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    },
                                  }}
                                  size="small"
                                  onClick={() => handleEditing(item)}
                                  variant="contained"
                                  label={<b style={{ color: "darkblue" }}>Edit</b>}
                                />
                              </Typography>
                              <div style={{ marginLeft: "auto" }}>
                                <Chip
                                  color="error"
                                  variant="outlined"
                                  label="Delete"
                                  onClick={() => deleteThing(item.id)}
                                  deleteIcon={<Cancel />}
                                  sx={{
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                    minWidth: 0,
                                    m:1
                                  }}
                                  size="small"
                                />

                                 <Chip
                                  color="success"
                                  variant="contained"
                                  label= {item.default_structure? "Default" : "Set Default"}
                                  onClick={() => setDefaultStructure(item.id)}
                                  sx={{
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                    minWidth: 0,
                                    m:1
                                  }}
                                  size="small"
                                /> 
                              </div>
                            </Box>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                  ) : (
                    <Typography
                      sx={{ textAlign: "center", m: 5 }}
                      variant="h4"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>No Structures available, Create one <span onClick={() => setValue1(1)} style={{ color:'blue', textDecoration:'underline', cursor:'pointer' }}>Here</span></b>
                    </Typography>
                  )}
              </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value1} index={1}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Structure Name"
                      value={structure_name}
                      onChange={(e) => setStructure_name(e.target.value)}
                      type="text"
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {data &&
                        data.map((item) => (
                          <Box
                            sx={{
                              borderStyle: "groove",
                              padding: 1,
                              border: 2,
                              borderColor: selected_wids.includes(item.id)
                                ? item.color
                                : "white",
                              boxShadow:
                                "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
                              margin: "5px",
                              borderRadius: "10px",
                              display: "flex",
                              cursor: "pointer",
                            }}
                            onClick={() => toggleFWidgetSelection(item.id)}
                          >
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              sx={{ display: "flex" }}
                            >
                              <b style={{ mr: 2 }}>{item.widget_name}</b>
                              <Tooltip
                                title={
                                  <Box>
                                    {item?.flow_sources &&
                                      item?.flow_sources.map((flows_in) => (
                                        <Box key={flows_in.id}>
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {flows_in.source}:{" "}
                                              <span style={{ color: "white" }}>
                                                {flows_in.description}
                                              </span>
                                            </b>
                                          </Typography>
                                          <Divider
                                            variant="middle"
                                            sx={{ m: 1 }}
                                          />
                                        </Box>
                                      ))}
                                  </Box>
                                }
                              >
                                <WysiwygRoundedIcon />
                              </Tooltip>
                            </Typography>
                          </Box>
                        ))}
                    </Box>

                    <Box sx={{ mt:5 }}>
                      <Button
                        size="small"
                        color="error"
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={close_modal}
                      >
                        Close
                      </Button>

                      <Button
                        size="small"
                        color="success"
                        variant="contained"
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={createThing}
                        disabled={!selected_wids}
                      >
                        {editing_mode ? "Edit Structure" : "Create Structure"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </CustomTabPanel>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default SocietyAccountsDashboard;
